import React from "react";

import TagMeetingHeader from "../components/TagMeetingHeader";
import UploadImdComponent from "../components/UploadImdComponent";

const UploadImdPage = () => {
  return (
    <>
      <TagMeetingHeader headerName="Upload IMD" />
      <UploadImdComponent />
    </>
  );
};

export default UploadImdPage;
